var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},_vm._l((Object.entries(_vm.identificationDynamicFields)),function(ref){
var key = ref[0];
var dynamicField = ref[1];
return _c('div',{key:dynamicField.name,class:dynamicField.css_class
          ? dynamicField.css_class
          : {
              'col-6': dynamicField.type !== 'ckeditor',
              'col-12': dynamicField.type === 'ckeditor',
            }},[_c('input-widget',{attrs:{"hint":dynamicField.hint,"type":_vm.typeMap[dynamicField.type],"label":_vm.$t(dynamicField.label),"id":'identityVerificationDynamicField_' + key,"rules":_vm.getRules(key, dynamicField),"disabled":_vm.disabled},on:{"change":function($event){return _vm.onChange(key, dynamicField, $event)}},model:{value:(_vm.model[key]),callback:function ($$v) {_vm.$set(_vm.model, key, $$v)},expression:"model[key]"}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }